if ($('#orderNow').length > 0 && !$('#salesBanner').length) {
    $('.btn:not(.cta, .btn--noScrollTo)').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
        }, 1200);
    })
}

//- make sticky CTA bar flexible on height
if ($('#stickyBar').length > 0) {
    let stickyBarHeight = Math.floor($('#stickyBar').outerHeight());

    document.documentElement.style.setProperty('--stickyBarHeight', stickyBarHeight + 'px');
}